<template>
<div class="page article-page scrollbar-style">
    <CoolLightBox v-if="items.length>0" 
        :items="items" 
        :index="index"
        effect="swipe"
        @close="index = null">
    </CoolLightBox>
    <div class="container" v-if="item" style="height:100%">
        <div class="grid">
            <div class="row">
            <div class="cell-sm-full cell-md-10">
                <h3>{{item.title}}</h3>
                <h5>Γιώργος Γκιζάρης</h5>
                <span style="cursor:pointer;color:yellow;font-size:14px" @click="()=>{this.$router.push('/')}"><span class="mif-backspace mif-2x"></span></span>
            </div>
            <div class="cell-sm-full cell-md-2" style="font-size:12px">
                    <div><strong>Τηλ:</strong>  6976359583</div>
                    <div><strong>Email:</strong>  gguizaris@hotmail.com</div>
                </div>
            <div class="cell-full">
                <div style="color:#aaa;font-size:14px">
                    {{item.description}}
                </div>
            </div>
            </div>
        </div>
        <vue-masonry-gallery :imgsArr="images" @click="onImgClick"></vue-masonry-gallery>
        
    </div>
    
</div>
</template>

<script>
import axios from 'axios';
import _ from 'underscore';
import settings from '../../settings.js';
import VueMasonryGallery from "vue-masonry-gallery";
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {
    props:{
        id:undefined
    },
    data(){
      return {
          item:undefined,
          images:[],
          index:null,
          items:[]
      }  
    },
    components:{
        CoolLightBox,
        VueMasonryGallery
    },
    mounted(){
        const action=async ()=>{ 
            let r=await axios.post(`${settings.serviceUrl}article/get`,{id:this.id});
            this.item=r.data.payload;
            this.images=this.item.imageUrls.split(';').map((fn,idx)=>{return {
                id:idx,
                src:this.toFullUrl(fn),
                caption:''
            }});
            this.items=this.images.map((im)=>{return im.src;})
            console.log(this.items);

        };
        action();
    },
    methods:{
        toFullUrl(v){
            return `${settings.assetsBaseUrl}${v}`;
        },
        onImgClick(ev,{ index, value }){
            this.index=value.id;
        }
    }
}
</script>

<style lang="less">
.cool-lightbox{
    background-color: black !important;
}
.article-page{
    overflow-y: auto;
    overflow-x:hidden;
    padding-top:20px;
    height:100%;
    @media screen and (max-width: 768px){
        .hide-sm{
            display:none;
        }
    }

    @media screen and (max-width: 1300px){
        .hide-md{
            display:none;
        }
    }
    .vue-masonry-gallery-container .vue-masonry-gallery-scroll {
        position: relative;
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: hidden !important;
        -webkit-overflow-scrolling: touch;
    }
    .cool-lightbox-toolbar {

    z-index: 11000;
}
}
</style>